import { AppErrorBoundary } from './components/hoc/AppErrorBoundary';
import SessionRoot from './components/session/SessionRoot';
import { AppLayout } from './components/hoc/AppLayout';

export const App = () => {
	return (
		<AppLayout>
			<AppErrorBoundary>
				<SessionRoot />
			</AppErrorBoundary>
		</AppLayout>
	);
};
